import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var ArrowRightIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 8 14" }),
    React.createElement("path", { d: "M7.203 6.797a1 1 0 00-.219-.625L2.359.391.797 1.641l4.126 5.156-4.12 5.156 1.562 1.25L6.99 7.422a1 1 0 00.213-.625z" }))); };

export { ArrowRightIcon as default };
